import { useState, useEffect, useRef } from "react";
import {
  CustomText,
  Input,
  InputDate,
  SelectComponent
} from "../../../../../components";
import { fonts } from "../../../../../config";

import { masks, validations } from "../../../../../utils";
import { StylesForm } from "../../../styles";
import { Grid } from "@material-ui/core";
import { Visibility } from "@material-ui/icons";
import { LabelView, MyLabel } from "../../../../guestHome/GuestHome";
import PhoneInputWithCountrySelect from "react-phone-number-input";
import '../../../../../phone.css'

interface ICompanion {
  name?: string;
  email?: string;
  birthDate?: string;
  phone?: string;
  cpf?: string;
  passport?: string;
}

interface ICompanionFormProps {
  companion?: ICompanion;
  fileName: any;
  formRef: any;
  index: number;
  handleImageChange: (index?: number) => void;
  openModalViewImg: (data: { name: string; src: string }) => void;
  fileRef: any;
  updateIsUnderAge: (index: number, isUnderAge: boolean) => void;
  phone: any;
  setPhone: (phone:any, index:number)=> void;
}

export function CompanionForm({
  companion,
  fileName,
  formRef,
  index,
  handleImageChange,
  openModalViewImg,
  fileRef,
  updateIsUnderAge,
  phone,
  setPhone,
}: ICompanionFormProps) {
  const [birthDate, setBirthdate] = useState(companion?.birthDate || "");
  const [isUnderAge, setIsUnderAge] = useState(false);
  const [docType, setDocType] = useState<any>(
    companion?.cpf ? 1 : companion?.passport ? 2 : 1
  );
  setPhone(companion?.phone, index);

function setPhones(phone:any){
  setPhone(phone,index);
}

  useEffect(() => {
    if (birthDate) {
      const age = calculateAge(birthDate);
      setIsUnderAge(age < 15);

      if (age < 15 && fileName["other-" + index]) {
        handleImageClear();
      }
    }
  }, [birthDate, fileName]);

  const calculateAge = (date) => {
    const birthDate = new Date(date);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }
    return age;
  };

  const handleImageClear = () => {
    // Limpar o campo de imagem
    fileRef.current[`other-${index}`] = null;
    // Atualizar o estado do nome do arquivo
    fileName["other-" + index] = "";
  };

  return (
    <>
      <CustomText
        style={{ paddingBottom: "25px" }}
        fontSize={1.75}
        fontFamily={fonts.bold}
        textColor="#8D9B9C"
      >
        ACOMPANHANTE #{index + 1}
      </CustomText>
      <Grid alignItems="flex-start" container spacing={2}>
        <Grid item xs={12} md={6} lg={4}>
          <Input
            validation={validations.isValidFullname}
            label="NOME COMPLETO"
            name={"fullName" + index}
            defaultValue={companion?.name}
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <SelectComponent
            required={"*Campo Obrigatório"}
            name={`docType${index}`}
            label="TIPO DO DOCUMENTO"
            defaultValue={docType}
            onBlurCustom={() => {
              formRef?.testFieldError("documento", true);
            }}
            onChangeCustom={(v) => {
              setDocType(v);

              formRef?.clearValue(`docValue${index}`, false);

              if (v === 1) {
                formRef?.setFieldValidation(
                  `docValue${index}`,
                  validations.validateCPF
                );
              } else {
                formRef?.setFieldValidation(`docValue${index}`, (value) => {
                  return null;
                });
              }
            }}
            options={[
              { value: 1, label: "CPF" },
              { value: 2, label: "Passaporte" }
            ]}
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <Input
            mask={docType === 1 ? masks.CPF : undefined}
            name={`docValue${index}`}
            label={docType === 1 ? "CPF" : "Passaporte"}
            maskToSubmit={(e, ffHandler) => {
              let type = ffHandler?.getValue(`docType${index}`, false);

              if (type === 1) {
                return masks.removeNumberMask(e);
              } else {
                return e;
              }
            }}
            defaultValue={companion?.cpf ? companion?.cpf : companion?.passport}
            validation={(e, ffHandler) => {
              let type = ffHandler?.getValue(`docType${index}`, false);

              if (type === 1) {
                return validations.validateCPF(e);
              } else {
                return undefined;
              }
            }}
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <InputDate
            maxDate={new Date()}
            label="DATA NASCIMENTO"
            name={"birthday" + index}
            defaultValue={
              companion?.birthDate &&
              masks.formatInputDate(companion?.birthDate)
            }
            onChange={(date: string) => {
              setBirthdate(date);
            }}
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <Input
            validation={validations.isEmailValid}
            label="E-MAIL"
            name={"email" + index}
            defaultValue={companion?.email}
          />
        </Grid>
        <Grid item xs={12} md={6} lg={4}>
          <LabelView>
                    <MyLabel
                      className={"form-input-label-" + "telefone"?.replace(/\s/g, "")}
                    >
                      {"Telefone*"}
                    </MyLabel>
                  </LabelView>
                  <div style={{backgroundColor:"#E9E9E9", height:"48px", alignContent:"center", border:"0px", borderRadius:"5px", padding:"5px"}}>
                  <PhoneInputWithCountrySelect
                    placeholder="TELEFONE"
                    numberInputProps={{className:"focus:outline-none focus:ring-0",}}
                    value={phone.current[index]}
                    onChange={setPhones}
                  />
                  </div>
                  <div style={{paddingBottom:"25px"}}></div>
                  {/*
          <Input
            mask={masks.inputMaskTELWithDDD}
            label="TELEFONE"
            maskToSubmit={masks.removeNumberMask}
            name={"phone" + index}
            defaultValue={companion?.phone}
          />
          */}
        </Grid>

        <Grid item xs={12} md={6} lg={8}>
          <CustomText
            fontSize={1.75}
            fontFamily={fonts.semibold}
            textColor="#4D585A"
          >
            CADASTRO DA FACIAL**
          </CustomText>
          <StylesForm.InputImage 
                          style={{
                            opacity: isUnderAge ? 0.5 : 1,
                            backgroundColor:"#D39899", borderColor:"red", borderStyle:"solid",borderWidth:"2px"
                          }}>
            <StylesForm.InputImageClick
              onClick={(event) => {
                if (isUnderAge) {
                  event.preventDefault();
                }
              }}
              htmlFor={"fileInput" + index}
            >
              {Object.keys(fileName).find((a) => a === "other-" + index) &&
              fileName["other-" + index] ? (
                <CustomText
                  style={{
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    display: "block"
                  }}
                  textColor="#4D585A"
                  fontSize={2}
                  fontFamily={fonts.medium}
                >
                  {fileName["other-" + index]}
                </CustomText>
              ) : (
                <CustomText
                  textColor="#4D585A"
                  fontSize={2}
                  fontFamily={fonts.medium}
                >
                  Clique aqui para cadastrar facial
                </CustomText>
              )}
              <button
                id={"fileInput" + index}
                onClick={() => !isUnderAge && handleImageChange(index)}
                style={{ display: "none" }}
              ></button>
            </StylesForm.InputImageClick>

            {Boolean(fileName["other-" + index]) && (
              <StylesForm.InputView
                endIcon={<Visibility />}
                fullWidth={false}
                onClick={() =>
                  openModalViewImg({
                    name: fileName["other-" + index],
                    src: fileRef.current[`other-${index}`]
                  })
                }
              >
                Visualizar
              </StylesForm.InputView>
            )}
          </StylesForm.InputImage>
        </Grid>
      </Grid>
    </>
  );
}
